/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService } from '../../../services/peopleService';
/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";
import Content from "./content";

/* Styles */
import styles from "./styles";

const UpdateTeamActionModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription, submitCallback, setSelectedRow, setSelectedOption, selectedRow, role}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { getRoleOptions } = usePeopleService();

  const [roleOptions, setRoleOptions] = useState([]);
  const [userRole, setUserRole] = useState(String(selectedRow?.roleId));

useEffect(() => {
  (async () => {
    const optionRoles = await getRoleOptions('O_ROLE_NAME');
    setRoleOptions(optionRoles?.[0]?.options || []);
  })();
}, [showModal]);

  useEffect(() => {
    setSelectedOption(userRole)
  }, [showModal, userRole]);

  useEffect(() => {
    setUserRole(String(selectedRow?.roleId))
  }, [showModal]);

  const handleSaveModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={classes.modal}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={modalIcon}
      modalTitle={modalTitle}
      modalDescription={modalDescription}
      modalContent={
        <Content userRole={userRole} roleOptions={roleOptions} setUserRole={setUserRole} />
      }
      modalFooter={<Footer setShowModal={setShowModal} handleSaveModal={handleSaveModal} />}
      onExited={() => setSelectedRow(false)}
    />
  );
}

export default UpdateTeamActionModal;
